export default {
  id: 'EditPoster',
  code: 'CN',
  text: {
    'Poster': '海报',
    'Edit Poster': '编辑海报',
    'Poster Title': '海报标题',
    'Poster Content': '海报内容',
    'Save': '保存至草稿',
    'Publish': '发布',
    'Preview': '预览',
    'Enter poster title': '输入海报标题',
    'Please start to edit your poster at right side editor': '请在右边编辑框内开始编辑海报',
    'Proceed to delete item?': '你确定要删除这个项目吗？',
    'Delete Item': '删除项目',
    'Please enter poster title': '您尚未输入海报标题',
    'Please enter registration setup': '您尚未输入报名设置',
    'Please enter registration title': '您尚未输入报名设置标题',
    'Please enter registration price': '您尚未输入报名设置价格',
    'This poster has people registered, you can not edit poster': '当前海报已经有人报名了，您无法再次编辑海报。'
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster/locale.js